import COUNTRY_CODES from "@/assets/json/ISO3166-1.countries.json";

import AE from "@/assets/images/countries/AE.png"; // United Arab Emirates
import AR from "@/assets/images/countries/AR.png"; // Argentina
import AU from "@/assets/images/countries/AU.png"; // Australia
import BE from "@/assets/images/countries/BE.png"; // BE (Belgium) is used for Europe Union
import BR from "@/assets/images/countries/BR.png"; // Brazil
import CA from "@/assets/images/countries/CA.png"; // Canada
import CH from "@/assets/images/countries/CH.png"; // Switzerland
import CL from "@/assets/images/countries/CL.png"; // Chile
import CN from "@/assets/images/countries/CN.png"; // China
import CO from "@/assets/images/countries/CO.png"; // Colombia
import EG from "@/assets/images/countries/EG.png"; // Egypt
import GB from "@/assets/images/countries/GB.png"; // United Kingdom
import HK from "@/assets/images/countries/HK.png"; // Hong Kong
import ID from "@/assets/images/countries/ID.png"; // Indonesia
import IL from "@/assets/images/countries/IL.png"; // Israel
import IN from "@/assets/images/countries/IN.png"; // India
import JP from "@/assets/images/countries/JP.png"; // Japan
import KE from "@/assets/images/countries/KE.png"; // Kenya
import KR from "@/assets/images/countries/KR.png"; // South Korea
import MX from "@/assets/images/countries/MX.png"; // Mexico
import NZ from "@/assets/images/countries/NZ.png"; // New Zealand
import NG from "@/assets/images/countries/NG.png"; // Nigeria
import PH from "@/assets/images/countries/PH.png"; // Philippines
import QA from "@/assets/images/countries/QA.png"; // Qatar
import RU from "@/assets/images/countries/RU.png"; // Russian Federation
import RW from "@/assets/images/countries/RW.png"; // Rwanda
import SA from "@/assets/images/countries/SA.png"; // Saudi Arabia
import SG from "@/assets/images/countries/SG.png"; // Singapore
import TH from "@/assets/images/countries/TH.png"; // Thailand
import TW from "@/assets/images/countries/TW.png"; // Taiwan
import US from "@/assets/images/countries/US.png"; // United States of America
import ZA from "@/assets/images/countries/ZA.png"; // South Africa

import NO from "@/assets/images/countries/NO.png"; // Norway
import SE from "@/assets/images/countries/SE.png"; // Sweden
import FI from "@/assets/images/countries/FI.png"; // Finland

type COUNTRY_IMAGE_URL = {
  [key in keyof typeof COUNTRY_CODES]?: string;
};

export const COUNTRY_IMAGE_URLS: COUNTRY_IMAGE_URL = {
  AE: AE,
  AR: AR,
  AU: AU,
  BE: BE,
  BR: BR,
  CA: CA,
  CH: CH,
  CL: CL,
  CN: CN,
  EG: EG,
  GB: GB,
  HK: HK,
  ID: ID,
  IL: IL,
  IN: IN,
  JP: JP,
  KE: KE,
  KR: KR,
  MX: MX,
  NG: NG,
  PH: PH,
  QA: QA,
  RU: RU,
  SA: SA,
  SG: SG,
  TH: TH,
  TW: TW,
  US: US,
  ZA: ZA,
  CO: CO,
  NZ: NZ,
  RW: RW,
  NO: NO,
  SE: SE,
  FI: FI,
};
